import { Action } from '@ngrx/store';
import { RecipeModifyFormValues } from '../../models/form-values';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';

export enum BucketsActionTypes {
  FETCH_BUCKETS = '[Bulk CEM UL Modify] Fetch buckets',
  ADD_BUCKETS = '[Bulk CEM UL Modify] Add buckets',
  CLEAR_BUCKETS = '[Bulk CEM UL Modify] Clear buckets',
  SET_BUCKET = '[Bulk CEM UL Modify] Set bucket',
  NO_ACTION = '[Bulk CEM UL Modify] No Action buckets',
  LOAD_BUCKETS = '[Bulk CEM UL Modify] Load order buckets',
  LOAD_BUCKETS_ERROR = '[Bulk CEM UL Modify] Load order buckets error',
}

export class FetchBuckets implements Action {
  readonly type = BucketsActionTypes.FETCH_BUCKETS;
  constructor(public payload: { orderFormId: number; orderId: number }) {}
}

export class LoadBuckets implements Action {
  readonly type = BucketsActionTypes.LOAD_BUCKETS;
  constructor(public payload: { orderFormId: number; order: Order }) {}
}

export class AddBuckets implements Action {
  readonly type = BucketsActionTypes.ADD_BUCKETS;
  constructor(public payload: { orderFormId: number; orderId: number; buckets: RecipeModifyFormValues[] }) {}
}

export class ClearBuckets implements Action {
  readonly type = BucketsActionTypes.CLEAR_BUCKETS;
  constructor(public payload: { orderFormId: number }) {}
}

export class NoAction implements Action {
  readonly type = BucketsActionTypes.NO_ACTION;
  constructor() {}
}

export class SetBucketAction implements Action {
  readonly type = BucketsActionTypes.SET_BUCKET;
  constructor(public payload: { bucket: RecipeModifyFormValues; recipe: RecipeModifyFormValues }) {}
}

export class LoadBucketsError implements Action {
  readonly type = BucketsActionTypes.LOAD_BUCKETS_ERROR;
  constructor() {}
}

export type BucketActions =
  | FetchBuckets
  | AddBuckets
  | ClearBuckets
  | NoAction
  | SetBucketAction
  | LoadBuckets
  | LoadBucketsError;
